import { brand } from "../config/brand";
import { SectionHeader } from "../components/SectionHeader";
import { StatusPill } from "../components/StatusPill";
import { fetchDashboardSettings } from "../lib/dashboard";
import { DashboardStateView, useDashboardQuery } from "../hooks/useDashboardQuery";
import { liveTone } from "../lib/status";

export function SettingsPage() {
  const state = useDashboardQuery(fetchDashboardSettings);

  return (
    <>
      <div className="page-header">
        <div>
          <h1>Settings</h1>
          <p>Brand and tenant safety posture. No secrets stored in the frontend.</p>
        </div>
        <StatusPill label="Read-only" tone="neutral" />
      </div>
      <DashboardStateView
        state={state}
        emptyTitle="Settings unavailable"
        emptyDetail="Unable to load tenant settings for this session."
      >
        {(data) => (
          <div className="panel">
            <SectionHeader title="Environment" subtitle="Public and tenant-safe configuration only" />
            <div className="panel-body kv-grid">
              <div className="kv-item">
                <div className="k">Product name</div>
                <div className="v">{data.productName || brand.productName}</div>
              </div>
              <div className="kv-item">
                <div className="k">Alternate brand</div>
                <div className="v">{brand.alternateProductName}</div>
              </div>
              <div className="kv-item">
                <div className="k">API base mode</div>
                <div className="v mono">{data.apiBaseMode}</div>
              </div>
              <div className="kv-item">
                <div className="k">Custom domain</div>
                <div className="v">
                  {data.domainStatus?.customDomainProven
                    ? "Proven (canonical redirect + HSTS enabled)"
                    : data.domainStatus?.customDomainConfigured
                      ? "Configured (not proven — attach gate pending)"
                      : "Not configured"}
                </div>
              </div>
              <div className="kv-item">
                <div className="k">Canonical web origin</div>
                <div className="v mono">{data.domainStatus?.canonicalWebOrigin || "—"}</div>
              </div>
              <div className="kv-item">
                <div className="k">Canonical API origin</div>
                <div className="v mono">{data.domainStatus?.canonicalApiOrigin || "—"}</div>
              </div>
              <div className="kv-item">
                <div className="k">Railway fallback web</div>
                <div className="v mono">{data.domainStatus?.railwayFallbackWebOrigin || "—"}</div>
              </div>
              <div className="kv-item">
                <div className="k">Tenant</div>
                <div className="v mono">{data.tenantId}</div>
              </div>
              <div className="kv-item">
                <div className="k">Storage mode</div>
                <div className="v">{data.storageMode}</div>
              </div>
              <div className="kv-item">
                <div className="k">Viewer principal</div>
                <div className="v mono">
                  {data.viewer
                    ? `${data.viewer.principalType}@${data.viewer.homeTenantId}`
                    : "—"}
                </div>
              </div>
              <div className="kv-item">
                <div className="k">Execution mode</div>
                <div className="v">{data.safety.executionMode}</div>
              </div>
              <div className="kv-item">
                <div className="k">Bridge mode</div>
                <div className="v">{data.safety.bridgeMode}</div>
              </div>
              <div className="kv-item">
                <div className="k">Live flags</div>
                <div className="v">
                  <StatusPill
                    label={
                      data.safety.liveExecutionEnabled
                        ? "Live execution enabled"
                        : "Live execution disabled"
                    }
                    tone={liveTone(data.safety.liveExecutionEnabled)}
                  />
                </div>
              </div>
              <div className="kv-item">
                <div className="k">Support email</div>
                <div className="v">{brand.supportEmail}</div>
              </div>
            </div>
          </div>
        )}
      </DashboardStateView>
    </>
  );
}
